import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  // faBell,
  // faBullhorn,
  // faCalendarXmark,
  // faCircleNodes,
  // faFileInvoiceDollar,
  // faPeace,
  faPieChart,
  //faSliders,
  faTruckFast
} from '@fortawesome/free-solid-svg-icons';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const faqBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Pages',
    url: '#!'
  },
  {
    label: 'Faq',
    active: true
  }
];
export interface Faq {
  id: number;
  title: string;
  details: string;
}

export const faqs: Faq[] = [
  {
    id: 1,
    title: 'What is NuPitch?',
    details: `NuPitch is a mobile application designed to assist filmmakers in creating compelling pitch decks for their film and TV projects.`
  },
  {
    id: 2,
    title: `How can NuPitch benefit filmmakers?`,
    details: `NuPitch simplifies the process of creating pitch decks, making it easier for filmmakers to attract investors and collaborators by presenting their projects professionally.`
  },
  {
    id: 3,
    title: `Can I use the NuPitch now?`,
    details: `We’re currently in closed beta for the NuPitch app. Please sign up to our waiting list. We’re rolling out access in batches.`
  },
  {
    id: 4,
    title: `Is NuPitch suitable for both independent and studio filmmakers?`,
    details: `Yes, NuPitch is designed to be versatile and can be used by both independent filmmakers and those working with larger studios.`
  },
  {
    id: 6,
    title: `How much will the app cost?`,
    details: `There will be two tiers available, there is a Free version available to all students, a Pro version for professionals and an Agency version which require annual  subscriptions. For further details, see our pricing page.`
  }
];

export interface FaqType {
  question: string;
  answer: string;
}

export interface FaqCategory {
  id: string;
  name: string;
  icon: IconProp;
  description: string;
  category?: string;
  topFaqs: FaqType[];
  faqs: FaqType[];
}

export const faqCategories: FaqCategory[] = [
  {
    id: 'sale-101',
    name: 'Sales',
    icon: faPieChart,
    description:
      'Answer the most frequently asked questions about your products & services here.',
    category: 'popular',
    topFaqs: [
      {
        question: 'What features does NuPitch offer?',
        answer:
          'NuPitch offers features such as customizable templates, AI-driven content suggestions, financial projection tools, real-time collaboration, and multimedia integration.'
      },
      {
        question: 'Can I track how many views my pitch deck is getting?',
        answer:
          'Yes, on the Professional plan you can see all the statistics (such as how many views, when, for how long and in which regions) in your dashboard.'
      },
      {
        question: 'Is NuPitch available for iOS and Android devices?',
        answer:
          'Yes, NuPitch is available for both iOS and Android platforms as a webapp for now.'
      }
    ],
    faqs: [
      {
        question: 'Does NuPitch use AI?',
        answer:
          'Users have the option to use AI when creating or editing their pitch decks.'
      },
      {
        question: 'Can I use NuPitch for different types of film genres?',
        answer:
          'Yes, NuPitch provides templates and content suggestions tailored to various film genres, ensuring your pitch deck is relevant to your project.'
      },
      {
        question:
          'Is NuPitch suitable for both novice and experienced filmmakers?',
        answer:
          'NuPitch is user-friendly and caters to filmmakers of all experience levels. Novices can use templates, while experienced filmmakers can customize their decks extensively.'
      },
      {
        question: 'Are my pitch deck data and projects secure with NuPitch?',
        answer:
          'Yes, NuPitch takes data security seriously and employs encryption and other security measures to protect your information.'
      },
      {
        question:
          'Is NuPitch a free application, or does it require a subscription?',
        answer:
          'NuPitch offers both free and premium subscription plans. The free version provides basic features and retains a NuPitch watermark on all pitch decks published, while the premium plan offers advanced tools and customization options. See pricing page for more information.'
      }
    ]
  },
  {
    id: 'delivery-101',
    name: 'Delivery',
    icon: faTruckFast,
    description:
      'Answer each & every question about your product and service delivery, maintain customers.',
    topFaqs: [
      {
        question:
          'Can I collaborate with team members or investors in real-time on my pitch deck?',
        answer:
          'This feature is on our roadmap. NuPitch will facilitate real-time collaboration, allowing you to work with team members, partners, or investors to create and refine your pitch deck.'
      },
      {
        question:
          'Can I export my pitch deck for presentations and sharing with investors?',
        answer:
          'Yes, NuPitch allows you to export your pitch deck in various formats, making it easy to present and share with potential investors.'
      }
    ],
    faqs: [
      {
        question:
          'Does NuPitch offer any educational resources or tips on creating effective pitch decks?',
        answer:
          'Yes, NuPitch provides educational content and tips to help users create compelling pitch decks and improve their chances of securing funding.'
      },
      {
        question:
          'Is NuPitch actively updated with new features and improvements?',
        answer:
          'Yes, NuPitch is regularly updated to enhance user experience and provide new features based on user feedback.'
      }
    ]
  }
];
